import { BaseSelectors } from '@makemydeal/dr-activities-common';
import type { AdditionalSelectors } from '../types/AdditionalSelectors';

export class Selectors extends BaseSelectors {
    constructor(public sliceName: string, public additionalSelectors: AdditionalSelectors) {
        super(sliceName);
    }
}
